import React from 'react';
import { useSelector } from 'react-redux';
import NoImage from '../../../assets/images/no-image.png';

const TransferDetails = ({transferItem, resourceKeys}) => {
    const currency = useSelector(
            (state) => state.currencyDetails.currentCurrency
          );

    return (
        <>
             <div className="box_wrap SPdetWrap common_bdrBtm w-100 p-4">
                    <h4 className="SPdethead">{resourceKeys.your_transfers || 'Your Transfers'} </h4>
                    <div className="itenary-item">
                        <div className="itenary-head d-flex flex-wrap align-items-center">
                        <div className="itenary-day-label">{resourceKeys.Day || 'Day'} {transferItem?.DayNo}</div>
                        <h3>
                        {transferItem.PickupPoint} <span>- </span> <span>{transferItem.DropoffPoint}</span>
                        </h3>
                        </div>
                        <div className="hotel-room-details">
                        <div className="row">
                            <div className="col-lg-1 col-md-2 col-4 hotel-room-thumb pl-0">
                            <img
                                src={transferItem.Image || NoImage}
                                className="packTransPic"
                                alt="Transfer Image"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = NoImage;
                                }}
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-8 room-details-listing">
                            <h5>{transferItem.VehicleName}</h5>
                            <span>{transferItem.DepartureTime} {transferItem?.ReturnTime ? '|' : ''}  {transferItem.ReturnTime}</span>
                            <p>{resourceKeys.maximum_capacity || 'Maximum Capacity'}: {transferItem.MaximumCapacity}</p>
                            </div>
                            <div className="col-lg-2 col-md-6 col-6 d-flex align-items-center room-details-listing">
                            <ul className="spHtlDtls">
                                {/* <h5>{resourceKeys.persons || 'Persons'}</h5>
                                <li>
                                <i className="htladultIcon" />
                                <span>1 {resourceKeys.Adult || 'Adult'}</span>
                                </li>
                                <li>
                                <i className="htlchildIcon" />
                                <span>1 {resourceKeys.Child || 'Child'}</span>
                                </li> */}
                            </ul>
                            </div>
                            <div className="col-lg-2 col-md-6 col-6 d-flex align-items-center room-details-price">
                            <span>
                                {transferItem?.Price > 0 && (
                                    <>
                                  <span>{currency}</span> <span>{transferItem?.Price}</span>
                                  </>
                                )}
                            </span>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6 d-flex align-items-center justify-content-end room-select pr-0">
                            {/* <span className="theme_btnStyle ">{resourceKeys.Selected || 'Selected'}</span> */}
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
        </>
    );
}

export default TransferDetails;
